const qucikView = (function () {
  return {
    inint: function () {
      this.toggleQuickView();
      this.updateQuantity();
    },
    renderQuickView: function (dataProductHandle, el, body, overlayBody) {
      const _this = this;
      const productHandleTemplateUrl = '/products/' + dataProductHandle + '?view=card_quick_view';
      const contentModal = document.querySelector('.tp-modal-quick-view');
      const iconQuickView = el.querySelector('.icon-quick-view');
      const iconLoading = el.querySelector('.loading-icon');
      const textAddToCart = el.querySelector('.text-add-to-cart');
      const iconLoadingCart = el.querySelector('.tp-loading-cart');
      iconQuickView?.classList.add('hidden');
      textAddToCart?.classList.add('opacity-0');
      iconLoading?.classList.remove('hidden');
      iconLoadingCart?.classList.remove('opacity-0');

      contentModal.innerHTML = '';
      const parser = new DOMParser()
      fetch(productHandleTemplateUrl)
        .then(response => response.text())
        .then(function (data) {
          const docProduct = parser.parseFromString(data, "text/html");
          const cardWrapper = docProduct.querySelector('.tp-quick-view')
          contentModal.appendChild(cardWrapper)
          _this.swiperPrd();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          body.querySelector('.tp-modal-quick-view').classList.add('show');
          document.querySelector('html').classList.add('tp-over-flow-hidden');
          overlayBody.classList.add('is-visible-qucikview');
          iconQuickView?.classList.remove('hidden');
          textAddToCart?.classList.remove('opacity-0');
          iconLoading?.classList.add('hidden');
          iconLoadingCart?.classList.add('opacity-0');
        });
    },
    swiperPrd: function () {
      const quickViewmain = document.querySelector('.tp-modal-quick-view');
      const thumbnail = quickViewmain.querySelector('.swiper-thumbnail');
      const swiperQuickView = quickViewmain.querySelector('.swiper-main-prd');
      let thumbSwiper = '';
      window.productThumb = new Swiper(thumbnail, {
        spaceBetween: 12,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-next-main-prd",
          prevEl: ".swiper-prev-main-prd",
        },
      });
      thumbSwiper = productThumb;
      window.productMain = new Swiper(swiperQuickView, {
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-next-main-prd",
          prevEl: ".swiper-prev-main-prd",
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });
    },
    toggleQuickView: function () {
      const _this = this;
      window.addEventListener('click', function (e) {
        const el = e.target;
        const body = this.document.querySelector('body');
        const overlayBody = body.querySelector('.tp-close-overlay');
        const closeQuickView = el.closest('.tp-quick-view');
        const searchOverlay = el.classList.contains('modal-search-toggle-open'); // fix click overlay conflict search popup
        if (el.classList.contains('button-quick-view')) {
          const dataProductHandle = el.dataset.productHandle;
          _this.renderQuickView(dataProductHandle, el, body, overlayBody);
        }
        if (el.classList.contains('tp-quick-view__close') || !el.classList.contains('button-quick-view') && !closeQuickView && !searchOverlay) {
          body.querySelector('.tp-modal-quick-view').classList.remove('show');
          overlayBody.classList.remove('is-visible-qucikview');
          document.querySelector('html').classList.remove('tp-over-flow-hidden');
        }
      })
    },
    updateQuantity: function () {
      const tpQuickView = document.querySelector('.tp-modal-quick-view');
      if (!tpQuickView) return;
      document.addEventListener('click', function (e) {
        const inputQty = tpQuickView?.querySelector('.tp-item__qty-input');
        const inputFormAddToCart = tpQuickView?.querySelector('.input-quantity-quick-view');
        if (inputFormAddToCart) {
          inputFormAddToCart.value = inputQty.value;
        }
      })
    }
  }
})();

qucikView.inint()
